class LoadMore extends HTMLElement {
    constructor() {
        super();
        const { container: productsContainerSelector, direction: direction } = this.dataset;
        this.actions = {
            direction: direction
        }
        this.selectors = {
            productsContainer: productsContainerSelector,
            paginationContainer: '.load-more-button-container',
            pagination: '.load-more-button'
        };

        this.elements = {
            productsContainer: document.querySelector(this.selectors.productsContainer),
            paginationContainer: this.querySelector(this.selectors.paginationContainer),
            button: this.querySelector(this.selectors.pagination)
        };

        if (!this.elements.productsContainer || !this.elements.button || !this.elements.paginationContainer) {
            console.log('Wrong configuration for load more');
            return;
        }

        this.addEventListener('click', this.loadNextPage.bind(this));
    }

    async loadNextPage(e) {
        e.preventDefault();

        const button = e.target.closest(this.selectors.pagination);
        if (button) {
            const nextPageUrl = button.getAttribute('href');
            this.toggleLoadingState(button, true);

            try {
                const result = await fetch(nextPageUrl);
                if (!result.ok) throw new Error(result.statusText);
                const nextPageContent = await result.text();
                this.handleNextPage(nextPageContent);
            } catch (error) {
                console.error('Error loading next page:', error);
            } finally {
                this.toggleLoadingState(button, false);
            }
        }
    }

    toggleLoadingState(button, isLoading) {
        button.disabled = isLoading;
        button.querySelector('.loading__spinner').classList.toggle('hidden', !isLoading);
        button.querySelector('span').textContent = isLoading ? 'Loading...' : 'Load More';
    }

    handleNextPage(nextPageContent) {
        const nextPageHtml = new DOMParser().parseFromString(nextPageContent, 'text/html');
        const nextPageProducts = nextPageHtml.querySelector(this.selectors.productsContainer);
        const nextPagination = nextPageHtml.querySelector(`load-more[data-direction=${this.actions.direction}]`);

        if (!nextPageProducts) {
            console.warn('Load more: Could not find any products in next page', nextPageHtml);
            return;
        }

        if (this.actions.direction == 'next') {
            this.elements.productsContainer.insertAdjacentHTML('beforeend', nextPageProducts.innerHTML);
        } else if (this.actions.direction == 'prev') {
            this.elements.productsContainer.insertAdjacentHTML('afterbegin', nextPageProducts.innerHTML);
        }

        // Update URL
        let nextPageUrl = new URL(window.location.href),
            pageNo = (this.actions.direction == 'next' ? this.getCurrentPage() + 1 : this.getCurrentPage() - 1);

        nextPageUrl.searchParams.set('page', pageNo);

        // Update State
        // @Todo: Page 3 -> load previous -> load next = wrong url
        window.history.pushState({ path: nextPageUrl.toString() }, '', nextPageUrl.toString());

        if (!nextPagination) {
            console.warn('Load More: We hit the last page.');
            this.innerHTML = '';
            return;
        }
        this.innerHTML = nextPagination.innerHTML;
    }

    getCurrentPage() {
        return parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    }
}

customElements.define('load-more', LoadMore);